const DEFAULT_DEV_API_URL = "http://localhost:4000"
const DEFAULT_PROD_API_URL = "https://api.xpress-ip.com"

export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? DEFAULT_PROD_API_URL : DEFAULT_DEV_API_URL)
